import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Root, classes } from './utils';
import Navbar from '../navbar/Navbar';
import Sidebar from '../sidebar/Sidebar';

const MainLayout = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  // Update the state whenever the screen is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1200) {
        // setOpenSidebar(true);
      }
      // else {
      //   setOpenSidebar(false);
      // }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Root className={classes.root}>
      <Navbar
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
        screenWidth={screenWidth}
      />

      <Box className={classes.mainSection}>
        <Sidebar
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
          screenWidth={screenWidth}
        />
        <Box
          className={classes.remainSpaceParentBox}
          width={
            screenWidth < 600
              ? '100vw'
              : openSidebar
                ? 'calc(100vw - 80px)'
                : 'calc(100vw - 250px)'
          }
        >
          {children}
        </Box>
      </Box>
    </Root>
  );
};

MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
export default MainLayout;
